module.exports = __webpack_public_path__ + "static/media/background-1.c6d42e2e.svg";